import { Injectable, Output, EventEmitter } from "@angular/core";
import { Http, Response, Headers } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { environment } from "../environments/environment";
import { AuthConfirmationResponse } from "@models/auth";
import { ActNowHttp } from "./act-now.http";

@Injectable()

export class AppService {
    public username: string;
    constructor(private http: ActNowHttp) { }

    private storeB64(data: string): string {
        let byteString = atob(data);
        let ab = new ArrayBuffer(byteString.length);
        let ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        let blob = new Blob([ab], { type: "application/json" });
        return window.URL.createObjectURL(blob);
    }

    public checkAuthentication(token: string): Observable<AuthConfirmationResponse> {
        return this.http.get(environment.apiUrl + "Auth")
            .map((response: Response) => <AuthConfirmationResponse>response.json())
            .catch(this.handleError);
    }

    private handleError(error: Response) {
        console.error(error);
        return Observable.throw(error.json() || "Server Error");
    }
}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/app/app.service.ts